import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Optional,
  Output,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { DataService } from "src/app/Services/dataservice.service";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { UserserviceService } from "src/app/Services/userservice.service";
import { FlowQueryModel } from "src/app/models/flowquerymodel";
import {
  getLoggedInUser,
  hasAdvancedAccessControlPlan,
  isCreatorPlanUser,
} from "src/app/shared/utils/plan.util";
import { getOrCreateDeviceId } from "src/app/shared/utils/device-access.util";
import { UpgradePlanDialogComponent } from "../upgrade-plan-dialog/upgrade-plan-dialog.component";
import { BundleService } from "src/app/Services/bundleservice.service";
import { RestrictedAccessDraft } from "src/app/shared/models/restricted-access-draft.model";

@Component({
  selector: "app-enhanced-restricted-access",
  templateUrl: "./enhanced-restricted-access.component.html",
  styleUrls: ["./enhanced-restricted-access.component.scss"],
})
export class EnhancedRestrictedAccessComponent implements OnInit {
  /** When true, render inline (no dialog chrome / publish). */
  @Input() embedded = false;
  /** When true with embedded, show only Restricted users + advanced UI. */
  @Input() restrictedOnly = false;
  @Input() mode: string | null = null;
  @Input() contentType: string | null = null;
  @Output() accessConfigured = new EventEmitter<any>();
  allUsers: any;
  tempUsers: any;
  selectedUsers: any[] = [];
  currentPage: number = 1;
  usersPerPage: number = 5;
  totalPages: number = 1;
  startIndex: number = 0;
  endIndex: number = 0;
  paginatedUsers: any[] = [];
  visiblePageNumbers: (number | string)[] = [];
  userData: any;
  profilePicture: string;
  name: string;
  email: string;
  website: string;
  phone: string;
  info: string;
  uname: string;
  showDefaultImage: boolean;
  input: string = "";
  isdisabled: boolean;
  flowModel: any;
  _steps: any[];
  coverImageUri: string;
  stepsImageUri: string;
  stepDescription: string;
  title: string;
  CategoryName: string;
  inames: any[];
  accessType: string;
  description: string;
  userDisplayName: any;
  showUsers: boolean;
  noResultReturned: boolean;
  isSearching: boolean = false;
  flowData: any;
  private searchTerms = new Subject<string>();

  // Access control: tabs + AND across enabled methods
  accessMode: "private" | "restricted" = "private";
  privateOption: "PrivateToMe" | "LinkAccess" = "PrivateToMe";
  activeTab: "advanced" | "users" = "users";
  showAdvancedAccessInfo = false;
  isSearchHidden: boolean = false;
  isSubmitting: boolean = false;

  canUseAdvancedAccess = false;
  /** Creator plan can open Restricted tabs but must upgrade to save a user allowlist. */
  canUseUserAllowlist = true;
  enforceNetwork = false;
  enforceGeo = false;
  enforceDevice = false;
  enforceCompanyEmail = false;
  allowedCidrs = "";
  allowedEmailDomains = "";
  allowedDeviceIds = "";
  geoLatitude: number | null = null;
  geoLongitude: number | null = null;
  geoRadiusValue = 1;
  geoRadiusUnit: "meter" | "kilometer" = "kilometer";
  advancedError = "";
  currentDeviceId = "";
  networkEntryDraft = "";
  deviceEntryDraft = "";
  emailDomainDraft = "";
  geoLocating = false;
  networkEntriesList: string[] = [];
  deviceEntriesList: string[] = [];
  emailDomainEntriesList: string[] = [];
  hasOtherAccessMethodsFlag = false;
  usersTabLoaded = false;
  isExistingFlow = false;
  savedAccessLabel = "";
  savedAccessDetails = "";
  private upgradeDialogRef: MatDialogRef<UpgradePlanDialogComponent> | null = null;

  /** @deprecated kept for hydrate compatibility; derived on publish */
  selectedAccessType: string = "LinkAccess";

  constructor(
    private userserviceService: UserserviceService,
    private router: Router,
    private flowServiceService: FlowServiceService,
    private dataService: DataService,
    private dialog: MatDialog,
    private bundleService: BundleService,
    @Optional()
    public dialogRef: MatDialogRef<EnhancedRestrictedAccessComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: {
      mode?: string;
      contentType?: string;
    }
  ) {
    try {
      this.flowModel = JSON.parse(localStorage.getItem("flowModel") || "null");
    } catch {
      this.flowModel = null;
    }
    this.searchTerms.pipe(debounceTime(2000)).subscribe(() => {
      this.performUsersSearch(0);
    });
  }

  get resolvedMode(): string {
    return this.mode || this.dialogData?.mode || "";
  }

  get resolvedContentType(): string {
    return (
      this.contentType ||
      this.dialogData?.contentType ||
      this.flowModel?.Type ||
      this.flowModel?.type ||
      ""
    );
  }

  get isBundleContent(): boolean {
    return String(this.resolvedContentType).toLowerCase() === "bundle";
  }

  get accessDialogTitle(): string {
    return this.isBundleContent ? "Bundle access" : "Access";
  }

  private isConfigureOnly(): boolean {
    return this.resolvedMode === "configure" || this.embedded;
  }

  private isBundleUpdate(): boolean {
    return this.isBundleContent && this.resolvedMode === "update";
  }

  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    try {
      this.flowData = JSON.parse(localStorage.getItem("flowModel") || "null");
    } catch {
      this.flowData = this.flowModel;
    }
    if (!this.flowModel) {
      this.flowModel = this.flowData || {};
    }
    this.canUseAdvancedAccess = hasAdvancedAccessControlPlan(
      this.userData || getLoggedInUser()
    );
    // Creator plan may browse Users / Advanced tabs; selecting users requires upgrade.
    this.canUseUserAllowlist = !isCreatorPlanUser(
      this.userData || getLoggedInUser()
    );
    this.currentDeviceId = getOrCreateDeviceId();
    if (this.userData != null) {
      this.userDisplayName = this.userData.firstName;
    }

    this.allUsers = [];
    this.tempUsers = [];
    this.selectedUsers = [];
    this.hydrateAdvancedFromFlow();
    this.hydrateAccessSelection();
    if (this.restrictedOnly || this.embedded) {
      this.accessMode = "restricted";
    }
    this.refreshAccessMethodFlags();
    if (!this.accessMode) {
      this.accessMode = "private";
      this.privateOption = "PrivateToMe";
    }
    if (this.accessMode === "private" && !this.privateOption) {
      this.privateOption = "PrivateToMe";
    }
    if (this.accessMode === "restricted") {
      if (this.hasAdvancedTogglesOn()) {
        this.setActiveTab("advanced");
        if (this.hasSelectedUsers && !this.usersTabLoaded) {
          this.usersTabLoaded = true;
          this.loadUsersTab();
        }
      } else {
        this.setActiveTab("users");
      }
    }
    this.captureSavedAccessSummary();
    if (!this.embedded) {
      this.loadSavedAdvancedAccessFromServer();
    }
  }

  /**
   * Build configure-mode access payload for parent wizards.
   * Returns null when Restricted selection is incomplete.
   */
  buildConfigureResult(): any | null {
    if (this.accessMode === "private" && this.privateOption === "PrivateToMe") {
      return this.buildResultObject(
        this.flowModel || {},
        "Private",
        null,
        true
      );
    }

    const selectedUsers =
      this.accessMode === "restricted" ? this.getSelectedUsers() : [];
    const hasUsers = (selectedUsers || []).length > 0;
    const advanced =
      this.accessMode === "restricted"
        ? this.buildAdvancedPayload()
        : this.emptyAdvancedPayload();

    if (this.accessMode === "restricted") {
      if (!this.validatePublish(hasUsers, advanced)) {
        return null;
      }
    }

    const restrictedAccessType =
      this.accessMode === "private"
        ? "LinkAccess"
        : this.deriveRestrictedAccessType(hasUsers);
    this.isSearchHidden = restrictedAccessType === "LinkAccess";
    this.selectedAccessType = restrictedAccessType;

    const restrictedAccessFlows = (selectedUsers || []).map((u) => ({
      EmailAddress: u.emailAddress || u.EmailAddress,
      UserName: u.userName || u.user?.userName || u.UserName,
      FirstName: u.firstName || u.user?.firstName || u.FirstName,
      ProfilePicUrl:
        u.profilePicUrl || u.user?.profilePicUrl || u.ProfilePicUrl,
    }));

    return this.buildResultObject(
      {
        ...(this.flowModel || {}),
        restrictedAccessFlows,
        RestrictedAccessFlows: restrictedAccessFlows,
        ...advanced,
      },
      "Restricted",
      restrictedAccessType,
      this.isSearchHidden
    );
  }

  /** Capture in-progress Restricted config for parent draft storage (no validation). */
  captureDraftSnapshot(): RestrictedAccessDraft {
    const selectedUsers = this.getSelectedUsers();
    const hasUsers = (selectedUsers || []).length > 0;
    const advanced = this.buildAdvancedPayload();
    const restrictedAccessType = this.deriveRestrictedAccessType(hasUsers);
    const isSearchHidden = restrictedAccessType === "LinkAccess";
    const savedAccessFlows = (selectedUsers || []).map((u) => ({
      EmailAddress: u.emailAddress || u.EmailAddress || u.user?.emailAddress,
      UserName: u.userName || u.user?.userName || u.UserName,
      FirstName: u.firstName || u.user?.firstName || u.FirstName,
      ProfilePicUrl:
        u.profilePicUrl || u.user?.profilePicUrl || u.ProfilePicUrl,
    }));

    return {
      restrictedAccessType,
      isSearchHidden,
      savedAccessFlows,
      savedAccessAdvanced: { ...advanced },
    };
  }

  emitAccessConfigured(): boolean {
    const result = this.buildConfigureResult();
    if (!result) {
      return false;
    }
    this.accessConfigured.emit(result);
    return true;
  }

  get hasSelectedUsers(): boolean {
    return (this.selectedUsers?.length ?? 0) > 0;
  }

  canSubmitAccess(): boolean {
    if (this.accessMode === "private") {
      return (
        this.privateOption === "PrivateToMe" ||
        this.privateOption === "LinkAccess"
      );
    }
    if (this.accessMode === "restricted") {
      return this.hasSelectedUsers || this.hasAdvancedTogglesOn();
    }
    return false;
  }

  setAccessMode(mode: "private" | "restricted"): void {
    this.accessMode = mode;
    this.advancedError = "";
    if (mode === "private" && !this.privateOption) {
      this.privateOption = "PrivateToMe";
    }
    if (mode === "restricted") {
      this.setActiveTab("users");
    } else if (this.activeTab === "advanced") {
      this.activeTab = "users";
    }
  }

  onAccessModeChange(): void {
    this.setAccessMode(this.accessMode);
  }

  onPrivateOptionChange(): void {
    this.isSearchHidden = this.privateOption === "LinkAccess";
    this.advancedError = "";
  }

  setActiveTab(tab: "advanced" | "users"): void {
    this.activeTab = tab;
    if (tab === "users" && !this.usersTabLoaded) {
      this.usersTabLoaded = true;
      this.loadUsersTab();
    }
  }

  toggleAdvancedAccessInfo(event?: Event): void {
    event?.stopPropagation();
    this.showAdvancedAccessInfo = !this.showAdvancedAccessInfo;
  }

  private loadUsersTab() {
    localStorage.removeItem("searchuserpageIndex");
    localStorage.setItem("searchuserpageIndex", "0");
    this.getPaginatedUsers(undefined, "0");
  }

  private hydrateAccessSelection(): void {
    const src = this.flowData || this.flowModel || {};
    this.initializeSelectedUsersFromRestricted();

    this.accessMode = "private";
    this.privateOption = "PrivateToMe";
    this.isSearchHidden = true;

    this.isExistingFlow = !!(
      src.rowKey ||
      src.RowKey ||
      src.uniqueId ||
      src.UniqueId
    );

    const accessType = String(src.accessType || src.AccessType || "").toLowerCase();
    const restrictedType = String(
      src.restrictedAccessType || src.RestrictedAccessType || ""
    ).toLowerCase();
    const hasUsers = (this.selectedUsers?.length ?? 0) > 0;
    const hasAdvanced = this.hasAdvancedTogglesOn();

    if (accessType === "private") {
      this.accessMode = "private";
      this.privateOption = "PrivateToMe";
      this.isSearchHidden = true;
      return;
    }

    if (accessType === "public") {
      this.accessMode = "private";
      this.privateOption = "PrivateToMe";
      return;
    }

    const isRestricted =
      accessType === "restricted" ||
      hasUsers ||
      hasAdvanced ||
      restrictedType === "selectedusers";

    if (!isRestricted) {
      return;
    }

    if (restrictedType === "linkaccess" && !hasUsers && !hasAdvanced) {
      this.accessMode = "private";
      this.privateOption = "LinkAccess";
      this.selectedAccessType = "LinkAccess";
      this.isSearchHidden = true;
      return;
    }

    this.accessMode = "restricted";
    this.selectedAccessType = hasUsers ? "SelectedUsers" : "LinkAccess";
    this.isSearchHidden = !hasUsers;
  }

  private captureSavedAccessSummary(): void {
    if (!this.isExistingFlow) {
      this.savedAccessLabel = "";
      this.savedAccessDetails = "";
      return;
    }

    if (this.accessMode === "private") {
      if (this.privateOption === "LinkAccess") {
        this.savedAccessLabel = "Anyone with the link";
        this.savedAccessDetails =
          "People with the link can open this flow. It stays hidden from search.";
        return;
      }
      this.savedAccessLabel = "Private to you";
      this.savedAccessDetails = "Only you can open this flow.";
      return;
    }

    const parts: string[] = [];
    const userCount = this.selectedUsers?.length ?? 0;
    if (userCount > 0) {
      parts.push(
        userCount === 1 ? "1 selected user" : `${userCount} selected users`
      );
    }
    if (this.enforceNetwork) {
      parts.push("company network");
    }
    if (this.enforceGeo) {
      parts.push("location");
    }
    if (this.enforceDevice) {
      parts.push("registered devices");
    }
    if (this.enforceCompanyEmail) {
      parts.push("company email");
    }

    this.savedAccessLabel = "Restricted";
    this.savedAccessDetails = parts.length
      ? `Access requires: ${parts.join(", ")}.`
      : "Only people who meet the rules you set can open this flow.";
  }

  private hydrateAdvancedFromFlow(src?: any) {
    src = src || this.mergeAccessSources(this.flowData, this.flowModel);
    this.enforceNetwork = this.pickBool(src, "enforceNetwork", "EnforceNetwork");
    this.enforceGeo = this.pickBool(src, "enforceGeo", "EnforceGeo");
    this.enforceDevice = this.pickBool(src, "enforceDevice", "EnforceDevice");
    this.enforceCompanyEmail = this.pickBool(
      src,
      "enforceCompanyEmail",
      "EnforceCompanyEmail"
    );
    this.allowedCidrs = this.pickStr(src, "allowedCidrs", "AllowedCidrs");
    this.allowedEmailDomains = this.pickStr(
      src,
      "allowedEmailDomains",
      "AllowedEmailDomains"
    );
    this.allowedDeviceIds = this.pickStr(
      src,
      "allowedDeviceIds",
      "AllowedDeviceIds"
    );
    this.hydrateGeoFence(src.geoFenceJson || src.GeoFenceJson);

    this.syncEntryListsFromStrings();
  }

  private loadSavedAdvancedAccessFromServer(): void {
    const rowKey =
      this.flowModel?.rowKey ||
      this.flowModel?.RowKey ||
      this.flowData?.rowKey ||
      this.flowData?.RowKey;
    if (!rowKey) {
      return;
    }

    this.flowServiceService.getAccessControl(String(rowKey)).subscribe(
      (accessControl) => {
        if (!accessControl) {
          return;
        }
        const normalized = this.normalizeAccessControl(accessControl);
        const merged = this.mergeAccessSources(
          this.flowData,
          this.flowModel,
          normalized
        );
        this.flowData = { ...(this.flowData || {}), ...merged };
        this.flowModel = { ...(this.flowModel || {}), ...merged };
        this.hydrateAdvancedFromFlow(merged);
        this.hydrateAccessSelection();
        this.refreshAccessMethodFlags();
        if (this.accessMode === "restricted" && this.hasAdvancedTogglesOn()) {
          this.setActiveTab("advanced");
        }
        this.captureSavedAccessSummary();
      },
      () => {
        /* keep locally hydrated values */
      }
    );
  }

  private normalizeAccessControl(src: any): any {
    if (!src) {
      return {};
    }
    const allowedCidrs = this.pickStr(src, "allowedCidrs", "AllowedCidrs");
    const allowedEmailDomains = this.pickStr(
      src,
      "allowedEmailDomains",
      "AllowedEmailDomains"
    );
    const allowedDeviceIds = this.pickStr(
      src,
      "allowedDeviceIds",
      "AllowedDeviceIds"
    );
    const geoFenceJson = src.geoFenceJson || src.GeoFenceJson || null;
    const enforceNetwork = this.pickBool(src, "enforceNetwork", "EnforceNetwork");
    const enforceGeo = this.pickBool(src, "enforceGeo", "EnforceGeo");
    const enforceDevice = this.pickBool(src, "enforceDevice", "EnforceDevice");
    const enforceCompanyEmail = this.pickBool(
      src,
      "enforceCompanyEmail",
      "EnforceCompanyEmail"
    );
    return {
      accessType: src.accessType || src.AccessType,
      AccessType: src.accessType || src.AccessType,
      restrictedAccessType: src.restrictedAccessType || src.RestrictedAccessType,
      RestrictedAccessType: src.restrictedAccessType || src.RestrictedAccessType,
      isSearchHidden: src.isSearchHidden ?? src.IsSearchHidden,
      IsSearchHidden: src.isSearchHidden ?? src.IsSearchHidden,
      enforceNetwork,
      EnforceNetwork: enforceNetwork,
      enforceGeo,
      EnforceGeo: enforceGeo,
      enforceDevice,
      EnforceDevice: enforceDevice,
      enforceCompanyEmail,
      EnforceCompanyEmail: enforceCompanyEmail,
      allowedCidrs,
      AllowedCidrs: allowedCidrs,
      allowedEmailDomains,
      AllowedEmailDomains: allowedEmailDomains,
      allowedDeviceIds,
      AllowedDeviceIds: allowedDeviceIds,
      geoFenceJson,
      GeoFenceJson: geoFenceJson,
    };
  }

  private mergeAccessSources(...sources: any[]): any {
    const merged: any = {};
    sources.forEach((src) => {
      if (!src || typeof src !== "object") {
        return;
      }
      const nested = src.accessControl || src.AccessControl || src.flowAccessControl;
      [src, nested].forEach((item) => {
        if (!item || typeof item !== "object") {
          return;
        }
        Object.keys(item).forEach((key) => {
          const value = item[key];
          if (this.hasUsableAccessValue(value)) {
            merged[key] = value;
          } else if (merged[key] == null) {
            merged[key] = value;
          }
        });
      });
    });
    return merged;
  }

  private hasUsableAccessValue(value: any): boolean {
    if (value == null || value === false) {
      return false;
    }
    if (typeof value === "string") {
      return value.trim() !== "";
    }
    if (Array.isArray(value)) {
      return value.length > 0;
    }
    return true;
  }

  private hydrateGeoFence(geoJson: any): void {
    if (!geoJson) {
      return;
    }
    try {
      let fence = typeof geoJson === "string" ? JSON.parse(geoJson) : geoJson;
      if (typeof fence === "string") {
        fence = JSON.parse(fence);
      }
      if (!fence || typeof fence !== "object") {
        return;
      }
      const latitude = fence.latitude ?? fence.Latitude ?? fence.lat ?? null;
      const longitude =
        fence.longitude ?? fence.Longitude ?? fence.lng ?? fence.lon ?? null;
      const radiusKm =
        fence.radiusKm ?? fence.RadiusKm ?? fence.radius ?? fence.Radius ?? 1;
      this.geoLatitude = latitude == null || latitude === "" ? null : Number(latitude);
      this.geoLongitude =
        longitude == null || longitude === "" ? null : Number(longitude);
      this.hydrateGeoRadiusFromKm(Number(radiusKm) || 1);
    } catch {
      /* ignore bad json */
    }
  }

  private pickBool(src: any, ...keys: string[]): boolean {
    if (!src) {
      return false;
    }
    for (const key of keys) {
      if (!Object.prototype.hasOwnProperty.call(src, key)) {
        continue;
      }
      const value = src[key];
      if (value === true || value === 1) {
        return true;
      }
      if (typeof value === "string" && value.toLowerCase() === "true") {
        return true;
      }
    }
    return false;
  }

  private pickStr(src: any, ...keys: string[]): string {
    if (!src) {
      return "";
    }
    for (const key of keys) {
      const normalized = this.normalizeListValue(src[key]);
      if (normalized) {
        return normalized;
      }
    }
    return "";
  }

  private normalizeListValue(value: any): string {
    if (value == null) {
      return "";
    }
    if (Array.isArray(value)) {
      return value
        .map((item) => String(item || "").trim())
        .filter(Boolean)
        .join(", ");
    }
    if (typeof value === "string") {
      const trimmed = value.trim();
      if (!trimmed) {
        return "";
      }
      if (trimmed.startsWith("[")) {
        try {
          const parsed = JSON.parse(trimmed);
          if (Array.isArray(parsed)) {
            return this.normalizeListValue(parsed);
          }
        } catch {
          /* keep original string */
        }
      }
      return trimmed;
    }
    return String(value).trim();
  }

  /** Advanced toggles/fields are Growth & Enterprise only — never leave them on for other plans. */
  private clearAdvancedOptionsForPlan(): void {
    this.enforceNetwork = false;
    this.enforceGeo = false;
    this.enforceDevice = false;
    this.enforceCompanyEmail = false;
  }

  hasAdvancedTogglesOn(): boolean {
    return (
      this.enforceNetwork ||
      this.enforceGeo ||
      this.enforceDevice ||
      this.enforceCompanyEmail
    );
  }

  refreshAccessMethodFlags(): void {
    this.hasOtherAccessMethodsFlag =
      this.hasAdvancedTogglesOn() || (this.selectedUsers?.length ?? 0) > 0;
  }

  private canEnableAdvancedOption(enable: boolean): boolean {
    if (enable && !this.canUseAdvancedAccess) {
      this.promptUpgradeForAdvanced();
      return false;
    }
    return true;
  }

  promptUpgradeForAdvanced(): void {
    this.openUpgradeDialog();
  }

  onLockedAdvancedClick(_event?: Event): void {
    if (!this.canUseAdvancedAccess) {
      this.openUpgradeDialog();
    }
  }

  toggleNetwork(): void {
    const next = !this.enforceNetwork;
    if (!this.canEnableAdvancedOption(next)) {
      return;
    }
    this.enforceNetwork = next;
    this.refreshAccessMethodFlags();
    if (next) {
      this.scrollExpandedAdvancedIntoView();
    }
  }

  toggleGeo(): void {
    const next = !this.enforceGeo;
    if (!this.canEnableAdvancedOption(next)) {
      return;
    }
    this.enforceGeo = next;
    this.refreshAccessMethodFlags();
    if (next) {
      this.scrollExpandedAdvancedIntoView();
    }
  }

  toggleDevice(): void {
    const next = !this.enforceDevice;
    if (!this.canEnableAdvancedOption(next)) {
      return;
    }
    this.enforceDevice = next;
    this.refreshAccessMethodFlags();
    if (next) {
      this.scrollExpandedAdvancedIntoView();
    }
  }

  toggleCompanyEmail(): void {
    const next = !this.enforceCompanyEmail;
    if (!this.canEnableAdvancedOption(next)) {
      return;
    }
    this.enforceCompanyEmail = next;
    this.refreshAccessMethodFlags();
    if (next) {
      this.scrollExpandedAdvancedIntoView();
    }
  }

  private scrollExpandedAdvancedIntoView(): void {
    if (!this.embedded) {
      return;
    }
    setTimeout(() => {
      const body = document.querySelector(
        ".enhanced-restricted-access-dialog.embedded-access .access-option-card.active .access-option-body"
      ) as HTMLElement | null;
      body?.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }, 50);
  }

  openUpgradeDialog(feature: string = "advanced-access"): void {
    if (this.upgradeDialogRef) {
      return;
    }

    // Defer so the click handler finishes before opening a second dialog.
    setTimeout(() => {
      if (this.upgradeDialogRef) {
        return;
      }

      this.upgradeDialogRef = this.dialog.open(UpgradePlanDialogComponent, {
        width: "780px",
        maxWidth: "100vw",
        maxHeight: "100vh",
        panelClass: "upgrade-plan-dialog-pane",
        autoFocus: false,
        restoreFocus: false,
        data: {
          returnUrl: "/pricing",
          feature,
        },
      });

      this.upgradeDialogRef.afterClosed().subscribe(() => {
        this.upgradeDialogRef = null;
      });
    }, 0);
  }

  promptUpgradeForUserAllowlist(): void {
    this.openUpgradeDialog("creator-publish-access");
  }

  onLockedUsersClick(_event?: Event): void {
    if (!this.canUseUserAllowlist) {
      this.promptUpgradeForUserAllowlist();
    }
  }

  private syncEntryListsFromStrings(): void {
    this.networkEntriesList = this.splitList(this.allowedCidrs);
    this.deviceEntriesList = this.splitList(this.allowedDeviceIds);
    this.emailDomainEntriesList = this.splitList(this.allowedEmailDomains);
  }

  private splitList(value: string): string[] {
    if (!value || !String(value).trim()) {
      return [];
    }
    return String(value)
      .split(/[,;\n]+/)
      .map((s) => s.trim())
      .filter(Boolean);
  }

  private joinList(entries: string[]): string {
    return entries.join(", ");
  }

  addNetworkEntry() {
    if (!this.canUseAdvancedAccess) {
      this.promptUpgradeForAdvanced();
      return;
    }
    const value = (this.networkEntryDraft || "").trim();
    if (!value) {
      return;
    }
    if (
      !this.networkEntriesList.some(
        (e) => e.toLowerCase() === value.toLowerCase()
      )
    ) {
      this.networkEntriesList = [...this.networkEntriesList, value];
      this.allowedCidrs = this.joinList(this.networkEntriesList);
    }
    this.networkEntryDraft = "";
  }

  removeNetworkEntry(index: number) {
    this.networkEntriesList = this.networkEntriesList.filter(
      (_, i) => i !== index
    );
    this.allowedCidrs = this.joinList(this.networkEntriesList);
  }

  addDeviceEntry() {
    if (!this.canUseAdvancedAccess) {
      this.promptUpgradeForAdvanced();
      return;
    }
    const value = (this.deviceEntryDraft || "").trim();
    if (!value) {
      return;
    }
    if (
      !this.deviceEntriesList.some(
        (e) => e.toLowerCase() === value.toLowerCase()
      )
    ) {
      this.deviceEntriesList = [...this.deviceEntriesList, value];
      this.allowedDeviceIds = this.joinList(this.deviceEntriesList);
    }
    this.deviceEntryDraft = "";
  }

  removeDeviceEntry(index: number) {
    this.deviceEntriesList = this.deviceEntriesList.filter(
      (_, i) => i !== index
    );
    this.allowedDeviceIds = this.joinList(this.deviceEntriesList);
  }

  addCurrentDevice() {
    this.deviceEntryDraft = this.currentDeviceId;
    this.addDeviceEntry();
  }

  addEmailDomain() {
    if (!this.canUseAdvancedAccess) {
      this.promptUpgradeForAdvanced();
      return;
    }
    let value = (this.emailDomainDraft || "").trim().replace(/^@+/, "");
    if (!value) {
      return;
    }
    if (
      !this.emailDomainEntriesList.some(
        (e) => e.toLowerCase() === value.toLowerCase()
      )
    ) {
      this.emailDomainEntriesList = [...this.emailDomainEntriesList, value];
      this.allowedEmailDomains = this.joinList(this.emailDomainEntriesList);
    }
    this.emailDomainDraft = "";
  }

  removeEmailDomain(index: number) {
    this.emailDomainEntriesList = this.emailDomainEntriesList.filter(
      (_, i) => i !== index
    );
    this.allowedEmailDomains = this.joinList(this.emailDomainEntriesList);
  }

  trackByEntry(_index: number, entry: string): string {
    return entry;
  }

  trackByUserEmail(_index: number, user: { emailAddress?: string }): string {
    return user?.emailAddress || String(_index);
  }

  useMyLocation() {
    if (!this.canUseAdvancedAccess) {
      this.promptUpgradeForAdvanced();
      return;
    }
    if (!navigator.geolocation) {
      this.advancedError = "Geolocation is not available in this browser.";
      return;
    }
    this.geoLocating = true;
    this.advancedError = "";
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        this.geoLatitude = pos.coords.latitude;
        this.geoLongitude = pos.coords.longitude;
        if (!this.geoRadiusValue || this.geoRadiusValue <= 0) {
          this.geoRadiusValue = this.geoRadiusUnit === "meter" ? 1000 : 1;
        }
        this.geoLocating = false;
      },
      () => {
        this.geoLocating = false;
        this.advancedError =
          "Could not get your location. Allow location access and try again.";
      },
      { enableHighAccuracy: true, timeout: 8000, maximumAge: 0 }
    );
  }

  setGeoRadiusUnit(unit: "meter" | "kilometer"): void {
    if (this.geoRadiusUnit === unit) {
      return;
    }

    const radiusKm = this.getGeoRadiusKm();
    this.geoRadiusUnit = unit;

    if (unit === "meter") {
      this.geoRadiusValue = Math.max(1, Math.round(radiusKm * 1000));
      return;
    }

    this.geoRadiusValue =
      radiusKm >= 0.1 ? Math.round(radiusKm * 10) / 10 : 0.1;
  }

  private hydrateGeoRadiusFromKm(radiusKm: number): void {
    const normalizedKm = Number(radiusKm) || 1;

    if (normalizedKm > 0 && normalizedKm < 1) {
      this.geoRadiusUnit = "meter";
      this.geoRadiusValue = Math.max(1, Math.round(normalizedKm * 1000));
      return;
    }

    this.geoRadiusUnit = "kilometer";
    this.geoRadiusValue = normalizedKm;
  }

  private getGeoRadiusKm(): number {
    if (!this.geoRadiusValue || this.geoRadiusValue <= 0) {
      return 0;
    }

    return this.geoRadiusUnit === "meter"
      ? this.geoRadiusValue / 1000
      : this.geoRadiusValue;
  }

  isGeoRadiusLikelyUnreliable(): boolean {
    return this.enforceGeo && this.getGeoRadiusKm() > 0 && this.getGeoRadiusKm() < 0.2;
  }

  private buildGeoFenceJson(): string | null {
    if (!this.enforceGeo) {
      return null;
    }
    const radiusKm = this.getGeoRadiusKm();
    if (
      this.geoLatitude == null ||
      this.geoLongitude == null ||
      !radiusKm
    ) {
      return null;
    }
    return JSON.stringify({
      Latitude: Number(this.geoLatitude),
      Longitude: Number(this.geoLongitude),
      RadiusKm: radiusKm,
    });
  }

  private buildAdvancedPayload() {
    const allowed = this.canUseAdvancedAccess;
    const enforceNetwork = allowed && this.enforceNetwork;
    const enforceGeo = allowed && this.enforceGeo;
    const enforceDevice = allowed && this.enforceDevice;
    const enforceCompanyEmail = allowed && this.enforceCompanyEmail;
    const allowedCidrs = enforceNetwork ? (this.allowedCidrs || "").trim() : "";
    const geoFenceJson = enforceGeo ? this.buildGeoFenceJson() : null;
    const allowedDeviceIds = enforceDevice
      ? (this.allowedDeviceIds || "").trim()
      : "";
    const allowedEmailDomains = enforceCompanyEmail
      ? (this.allowedEmailDomains || "").trim()
      : "";
    return {
      EnforceNetwork: enforceNetwork,
      enforceNetwork,
      EnforceGeo: enforceGeo,
      enforceGeo,
      EnforceDevice: enforceDevice,
      enforceDevice,
      EnforceCompanyEmail: enforceCompanyEmail,
      enforceCompanyEmail,
      AllowedCidrs: allowedCidrs,
      allowedCidrs: allowedCidrs,
      GeoFenceJson: geoFenceJson,
      geoFenceJson: geoFenceJson,
      AllowedDeviceIds: allowedDeviceIds,
      allowedDeviceIds: allowedDeviceIds,
      AllowedEmailDomains: allowedEmailDomains,
      allowedEmailDomains: allowedEmailDomains,
    };
  }

  private deriveRestrictedAccessType(hasUsers: boolean): string {
    // Advanced-only (geo/network/device/email) must stay LinkAccess.
    // SelectedUsers turns on the allowlist gate even when no users were picked.
    return hasUsers ? "SelectedUsers" : "LinkAccess";
  }

  private validatePublish(hasUsers: boolean, advanced: any): boolean {
    this.advancedError = "";
    if (this.accessMode === "private") {
      if (
        this.privateOption !== "PrivateToMe" &&
        this.privateOption !== "LinkAccess"
      ) {
        this.advancedError = "Select a private access option.";
        return false;
      }
      return true;
    }
    if (!this.validateAdvanced()) {
      return false;
    }
    if (!hasUsers && !this.hasAdvancedTogglesOn()) {
      this.advancedError =
        "Select at least one user or enable an advanced access option.";
      return false;
    }
    return true;
  }

  private validateAdvanced(): boolean {
    this.advancedError = "";
    if (!this.canUseAdvancedAccess) {
      if (
        this.enforceNetwork ||
        this.enforceGeo ||
        this.enforceDevice ||
        this.enforceCompanyEmail
      ) {
        this.advancedError =
          "Advanced access requires a Growth or Enterprise plan.";
        return false;
      }
      return true;
    }
    if (this.enforceNetwork && !(this.allowedCidrs || "").trim()) {
      this.advancedError =
        "Add at least one IP or CIDR for network restriction.";
      return false;
    }
    if (this.enforceGeo && !this.buildGeoFenceJson()) {
      this.advancedError =
        "Set latitude, longitude, and radius for the geo-fence.";
      return false;
    }
    if (this.enforceDevice && !(this.allowedDeviceIds || "").trim()) {
      this.advancedError = "Add at least one allowed device id.";
      return false;
    }
    if (this.enforceCompanyEmail && !(this.allowedEmailDomains || "").trim()) {
      this.advancedError = "Add at least one company email domain.";
      return false;
    }
    return true;
  }

  onAccessTypeChange() {
    this.isSearchHidden = this.selectedAccessType === "LinkAccess";
  }

  performUsersSearch(pageIndex) {
    this.noResultReturned = true;
    this.isSearching = true;

    this.allUsers = [];
    this.tempUsers = [];
    var email = "";
    if (this.userData != null && this.userData != undefined) {
      this.showUsers = false;
      email = this.userData.emailAddress;
    }
    this.showUsers = true;
    var flowQueryModel = new FlowQueryModel({
      category: "Users",
      searchString: this.input,
      userEmail: this.email,
      pageIndex: pageIndex,
    });

    this.userserviceService.searchInUsers(flowQueryModel).subscribe(
      (data) => {
        this.noResultReturned = false;

        if (data.allUsers.length > 0) {
          this.tempUsers = [];
          this.allUsers = [];
          data.allUsers.forEach((element) => {
            const user = {
              user: element,
              showFollow: false,
              followButtonText: element.followingText,
              EmailAddress: element.emailAddress,
            };
            this.allUsers.push(user);
          });

          this.tempUsers = this.allUsers;
          this.tempUsers.forEach((element) => {
            if (element.followButtonText === "Following") {
              element.followButtonText = "Following";
              element.followingcolor = "black";
              element.followingbgcolor = "white";
            } else {
              element.followButtonText = "Follow";
              element.followingcolor = "white";
              element.followingbgcolor = "#5ea1d8";
            }
          });

          this.checkForExistingSelections();
        } else {
          this.tempUsers = [];
        }

        this.currentPage = 1;
        this.updatePagination();
        this.isSearching = false;
      },
      (error) => {
        this.isSearching = false;
        this.noResultReturned = false;
        this.tempUsers = [];
        this.allUsers = [];
        this.updatePagination();
      }
    );
  }

  getPaginatedUsers(infiniteScroll, pageIndex) {
    var email = "";

    if (this.userData != null && this.userData != undefined) {
      email = this.userData.emailAddress;
    }

    var flowQueryModel = new FlowQueryModel({
      category: "Users",
      searchString: this.input,
      userEmail: this.email,
      pageIndex: pageIndex,
    });

    if (this.input !== "" && this.input !== undefined) {
      this.performUsersSearch(pageIndex);
    } else {
      this.isSearching = true;
      this.userserviceService.getAllUsers(flowQueryModel).subscribe(
        (data) => {
          if (data.allUsers.length > 0) {
            this.tempUsers = [];
            this.allUsers = [];
            data.allUsers.forEach((element) => {
              const user = {
                FlowId: element.rowKey,
                user: element,
                UserName: element.userName,
                ProfilePicUrl: element.profilePicUrl,
                FirstName: element.firstName,
                EmailAddress: element.emailAddress,
                showFollow: false,
                followButtonText: element.followingText,
              };
              this.allUsers.push(user);
            });
            this.tempUsers = this.allUsers;
            this.tempUsers.forEach((element) => {
              if (element.followButtonText === "Following") {
                element.followButtonText = "Following";
                element.followingcolor = "black";
                element.followingbgcolor = "white";
              } else {
                element.followButtonText = "Follow";
                element.followingcolor = "white";
                element.followingbgcolor = "#5ea1d8";
              }
            });

            this.checkForExistingSelections();
          } else {
            this.tempUsers = [];
            this.allUsers = [];
          }

          this.currentPage = 1;
          this.updatePagination();
          this.isSearching = false;
        },
        (error) => {
          this.isSearching = false;
          this.tempUsers = [];
          this.allUsers = [];
          this.updatePagination();
        }
      );
      this.showUsers = true;
    }
  }

  getAllUsers() {
    localStorage.removeItem("searchuserpageIndex");
    localStorage.setItem("searchuserpageIndex", "0");

    this.allUsers = [];
    this.tempUsers = [];
    this.currentPage = 1;
    this.getPaginatedUsers(undefined, "0");
  }

  checkIsUserLoggedIn() {
    if (this.userData === null) {
      this.router.navigate(["/login"]);
    }
  }

  publish() {
    if (this.isSubmitting || !this.canSubmitAccess()) {
      return;
    }

    if (this.userData == null) {
      this.router.navigate(["/login"]);
      return;
    }

    if (this.accessMode === "private" && this.privateOption === "PrivateToMe") {
      this.publishPrivateToMe();
      return;
    }

    const selectedUsers =
      this.accessMode === "restricted" ? this.getSelectedUsers() : [];
    const hasUsers = (selectedUsers || []).length > 0;
    const advanced =
      this.accessMode === "restricted"
        ? this.buildAdvancedPayload()
        : this.emptyAdvancedPayload();
    if (!this.validatePublish(hasUsers, advanced)) {
      return;
    }

    const restrictedAccessType =
      this.accessMode === "private"
        ? "LinkAccess"
        : this.deriveRestrictedAccessType(hasUsers);
    this.isSearchHidden = restrictedAccessType === "LinkAccess";
    this.selectedAccessType = restrictedAccessType;

    if (this.isConfigureOnly() && this.isBundleContent) {
      this.closeWithResult(
        this.flowModel,
        "Restricted",
        restrictedAccessType,
        this.isSearchHidden
      );
      return;
    }

    this.noResultReturned = true;
    this.isSubmitting = true;

    const restrictedAccessFlows = (selectedUsers || []).map((u) => ({
      EmailAddress: u.emailAddress || u.EmailAddress,
      UserName: u.userName || u.user?.userName || u.UserName,
      FirstName: u.firstName || u.user?.firstName || u.FirstName,
      ProfilePicUrl:
        u.profilePicUrl || u.user?.profilePicUrl || u.ProfilePicUrl,
    }));

    const existingRowKey = this.flowModel?.rowKey || this.flowModel?.RowKey;
    const updateAccessOnly =
      (this.resolvedMode === "update" && !!existingRowKey) || this.isBundleUpdate();

    if (updateAccessOnly) {
      const payload = {
        RowKey: existingRowKey,
        RestrictedAccessType: restrictedAccessType,
        IsSearchHidden: this.isSearchHidden,
        RestrictedAccessFlows: restrictedAccessFlows,
        SearchKeyWords:
          Array.isArray(this.flowModel?.searchKeyWords) &&
          this.flowModel?.searchKeyWords.length > 0
            ? this.flowModel?.searchKeyWords.join(",")
            : "",
        ...advanced,
      };

      const save$ = this.isBundleContent
        ? this.bundleService.setRestrictedAccessOptions(
            payload,
            this.userData.emailAddress
          )
        : this.flowServiceService.setRestrictedAccessOptions(
            payload,
            this.userData.emailAddress
          );

      save$.subscribe(
        (data) => {
          this.noResultReturned = false;
          this.isSubmitting = false;
          this.closeWithResult(
            data,
            "Restricted",
            restrictedAccessType,
            this.isSearchHidden
          );
        },
        (error) => {
          this.failPublish(error, "Failed to save access settings.");
        }
      );
      return;
    }

    this.flowModel.AccessType = "Restricted";
    this.flowModel.accessType = "Restricted";
    this.flowModel.RestrictedAccessType = restrictedAccessType;
    this.flowModel.restrictedAccessType = restrictedAccessType;
    this.flowModel.IsSearchHidden = this.isSearchHidden;
    this.flowModel.isSearchHidden = this.isSearchHidden;
    this.flowModel.restrictedAccessFlows = restrictedAccessFlows;
    this.flowModel.RestrictedAccessFlows = restrictedAccessFlows;
    Object.assign(this.flowModel, advanced);
    this.flowModel.searchKeyWords =
      this.flowModel.searchKeyWords &&
      this.flowModel.searchKeyWords.length > 0
        ? this.flowModel.searchKeyWords
        : "";

    this.flowServiceService
      .publishUserFlow(this.flowModel, this.userData.emailAddress)
      .subscribe(
        (data) => {
          const result = this.unwrapPublishResponse(data);
          if (result === undefined) {
            return;
          }
          this.noResultReturned = false;
          this.isSubmitting = false;
          this.closeWithResult(
            result,
            "Restricted",
            restrictedAccessType,
            this.isSearchHidden
          );
        },
        (error) => {
          this.failPublish(error, "Failed to publish flow.");
        }
      );
  }

  private publishPrivateToMe(): void {
    this.noResultReturned = true;
    this.isSubmitting = true;
    this.isSearchHidden = true;

    const existingRowKey = this.flowModel?.rowKey || this.flowModel?.RowKey;
    this.flowModel.AccessType = "Private";
    this.flowModel.accessType = "Private";
    this.flowModel.RestrictedAccessType = null;
    this.flowModel.restrictedAccessType = null;
    this.flowModel.IsSearchHidden = true;
    this.flowModel.isSearchHidden = true;
    this.flowModel.RowKey = existingRowKey;
    this.flowModel.rowKey = existingRowKey;
    this.flowModel.searchKeyWords =
      this.flowModel.searchKeyWords &&
      this.flowModel.searchKeyWords.length > 0
        ? Array.isArray(this.flowModel.searchKeyWords)
          ? this.flowModel.searchKeyWords.join(", ")
          : this.flowModel.searchKeyWords
        : "";

    if (this.resolvedMode === "update" && existingRowKey) {
      const save$ = this.isBundleContent
        ? this.bundleService.changeBundleAccess(
            this.flowModel,
            this.userData.emailAddress
          )
        : this.flowServiceService.saveFlowToServerAccessLevel(
            this.flowModel,
            this.userData.emailAddress
          );

      save$.subscribe(
        (data) => {
          this.noResultReturned = false;
          this.isSubmitting = false;
          this.closeWithResult(data || this.flowModel, "Private", null, true);
        },
        (error) => {
          this.failPublish(error, "Failed to save access settings.");
        }
      );
      return;
    }

    if (this.isConfigureOnly() && this.isBundleContent) {
      this.closeWithResult(this.flowModel, "Private", null, true);
      return;
    }

    this.flowServiceService
      .publishUserFlow(this.flowModel, this.userData.emailAddress)
      .subscribe(
        (data) => {
          const result = this.unwrapPublishResponse(data);
          if (result === undefined) {
            return;
          }
          this.noResultReturned = false;
          this.isSubmitting = false;
          this.closeWithResult(result, "Private", null, true);
        },
        (error) => {
          this.failPublish(error, "Failed to publish flow.");
        }
      );
  }

  private emptyAdvancedPayload() {
    return {
      EnforceNetwork: false,
      EnforceGeo: false,
      EnforceDevice: false,
      EnforceCompanyEmail: false,
      AllowedCidrs: "",
      GeoFenceJson: null,
      AllowedDeviceIds: "",
      AllowedEmailDomains: "",
    };
  }

  private unwrapPublishResponse(data: any): any {
    if (data && typeof data.type === "number") {
      if (data.type === 4) {
        return data.body || data;
      }
      return undefined;
    }
    return data;
  }

  private failPublish(error: any, fallback: string): void {
    this.noResultReturned = false;
    this.isSubmitting = false;
    this.advancedError =
      error?.error?.message || error?.error?.Message || fallback;
  }

  private buildResultObject(
    data: any,
    accessType: string,
    restrictedAccessType?: string | null,
    isSearchHidden?: boolean
  ): any {
    const payload =
      data && typeof data === "object" && !Array.isArray(data) ? data : {};
    const isRestricted = String(accessType || "").toLowerCase() === "restricted";
    return {
      ...payload,
      accessType,
      AccessType: accessType,
      restrictedAccessType,
      RestrictedAccessType: restrictedAccessType,
      isSearchHidden,
      IsSearchHidden: isSearchHidden,
      enforceNetwork: isRestricted && this.enforceNetwork,
      EnforceNetwork: isRestricted && this.enforceNetwork,
      enforceGeo: isRestricted && this.enforceGeo,
      EnforceGeo: isRestricted && this.enforceGeo,
      enforceDevice: isRestricted && this.enforceDevice,
      EnforceDevice: isRestricted && this.enforceDevice,
      enforceCompanyEmail: isRestricted && this.enforceCompanyEmail,
      EnforceCompanyEmail: isRestricted && this.enforceCompanyEmail,
      allowedCidrs: isRestricted ? this.allowedCidrs : "",
      AllowedCidrs: isRestricted ? this.allowedCidrs : "",
      allowedEmailDomains: isRestricted ? this.allowedEmailDomains : "",
      AllowedEmailDomains: isRestricted ? this.allowedEmailDomains : "",
      allowedDeviceIds: isRestricted ? this.allowedDeviceIds : "",
      AllowedDeviceIds: isRestricted ? this.allowedDeviceIds : "",
      geoFenceJson: isRestricted ? this.buildGeoFenceJson() : null,
      GeoFenceJson: isRestricted ? this.buildGeoFenceJson() : null,
      restrictedAccessFlows: isRestricted ? this.selectedUsers : [],
      RestrictedAccessFlows: isRestricted ? this.selectedUsers : [],
    };
  }

  private closeWithResult(
    data: any,
    accessType: string,
    restrictedAccessType?: string | null,
    isSearchHidden?: boolean
  ): void {
    this.close(
      this.buildResultObject(
        data,
        accessType,
        restrictedAccessType,
        isSearchHidden
      )
    );
  }

  close(data?: any) {
    if (this.dialogRef) {
      this.dialogRef.close(data);
      return;
    }
    if (data) {
      this.accessConfigured.emit(data);
    }
  }

  viewUserProfile(selectedUser) {
    if (this.userData != null) {
      if (
        this.userData.emailAddress === selectedUser.customerEmail ||
        this.userData.emailAddress === selectedUser.emailAddress
      ) {
        this.router.navigate(["/user-profile"]);
      } else {
        this.router.navigate(["/view-profile"]);
      }
      this.dataService.flowByCategorieschangeMessage(selectedUser);
    } else {
      this.router.navigate(["/login"]);
    }
  }

  searchUsers() {
    this.currentPage = 1;

    if (!this.input || this.input.trim() === "") {
      this.getAllUsers();
    } else {
      this.searchTerms.next(this.input);
    }
  }

  accessChanged() {
    this.updateSelectedUsersArray();
    this.refreshAccessMethodFlags();
    this.isdisabled = false;
  }

  onUserSelectionChange(user: any, isSelected: boolean) {
    if (!this.canUseUserAllowlist) {
      this.promptUpgradeForUserAllowlist();
      // Keep checkbox unchecked when Creator cannot save an allowlist.
      if (user.user) {
        user.user.IsAccessGiven = false;
      } else {
        user.IsAccessGiven = false;
      }
      return;
    }

    if (user.user) {
      user.user.IsAccessGiven = isSelected;
    } else {
      user.IsAccessGiven = isSelected;
    }

    if (isSelected) {
      const email = user.user?.emailAddress || user.EmailAddress;
      const exists = this.selectedUsers.some(
        (selected) => selected.emailAddress === email
      );

      if (!exists) {
        this.selectedUsers.push({
          emailAddress: email,
          userName: user.user?.userName || user.UserName,
          profilePicUrl: user.user?.profilePicUrl || user.ProfilePicUrl,
          firstName: user.user?.firstName || user.FirstName,
          IsAccessGiven: true,
        });
      }
    } else {
      const email = user.user?.emailAddress || user.EmailAddress;
      this.selectedUsers = this.selectedUsers.filter(
        (selected) => selected.emailAddress !== email
      );
    }

    this.accessChanged();
  }

  private checkForExistingSelections() {
    if (this.selectedUsers && this.selectedUsers.length > 0) {
      const selectedEmails = new Set(
        this.selectedUsers
          .map((u) => this.normalizeEmail(u.emailAddress || u.EmailAddress))
          .filter(Boolean)
      );
      this.allUsers.forEach((user) => {
        const email = this.normalizeEmail(
          user.user?.emailAddress || user.EmailAddress || user.emailAddress
        );
        if (email && selectedEmails.has(email)) {
          if (user.user) {
            user.user.IsAccessGiven = true;
          } else {
            user.IsAccessGiven = true;
          }
        }
      });
    }
  }

  private normalizeEmail(email: any): string {
    return String(email || "")
      .trim()
      .toLowerCase();
  }

  private updateSelectedUsersArray() {
    if (this.allUsers && this.allUsers.length > 0) {
      this.allUsers.forEach((user) => {
        if (user?.user?.IsAccessGiven || user?.IsAccessGiven) {
          const email = user.user?.emailAddress || user.EmailAddress;
          const exists = this.selectedUsers.some(
            (selected) => selected.emailAddress === email
          );

          if (!exists) {
            this.selectedUsers.push({
              emailAddress: email,
              userName: user.user?.userName || user.UserName,
              profilePicUrl: user.user?.profilePicUrl || user.ProfilePicUrl,
              firstName: user.user?.firstName || user.FirstName,
              IsAccessGiven: true,
            });
          }
        }
      });
    }

    if (this.tempUsers && this.tempUsers.length > 0) {
      this.tempUsers.forEach((user) => {
        if (user?.user?.IsAccessGiven || user?.IsAccessGiven) {
          const email = user.user?.emailAddress || user.EmailAddress;
          const exists = this.selectedUsers.some(
            (selected) => selected.emailAddress === email
          );

          if (!exists) {
            this.selectedUsers.push({
              emailAddress: email,
              userName: user.user?.userName || user.UserName,
              profilePicUrl: user.user?.profilePicUrl || user.ProfilePicUrl,
              firstName: user.user?.firstName || user.FirstName,
              IsAccessGiven: true,
            });
          }
        }
      });
    }
  }

  setRestrictedUsers() {
    if (
      this.flowModel.restrictedAccessFlows != null &&
      this.flowModel.restrictedAccessFlows != undefined
    ) {
      this.isdisabled = false;
      this.flowModel.restrictedAccessFlows.forEach((element) => {
        var userAccess = this.allUsers.filter(
          (x) => x.emailAddress == element.emailAddress
        )[0];
        if (userAccess) {
          if (userAccess.user) {
            userAccess.user.IsAccessGiven = true;
          } else {
            userAccess.IsAccessGiven = true;
          }
        }
      });

      this.allUsers = this.allUsers.sort((u) => u.IsAccessGiven).reverse();

      this.initializeSelectedUsersFromRestricted();
      this.refreshAccessMethodFlags();
    }
  }

  private initializeSelectedUsersFromRestricted() {
    const src = this.flowModel || this.flowData || {};
    const restrictedType = String(
      src.restrictedAccessType || src.RestrictedAccessType || ""
    ).toLowerCase();
    // Advanced-only (location/network/device/email) must not re-select leftover users.
    if (restrictedType === "linkaccess") {
      this.selectedUsers = [];
      this.refreshAccessMethodFlags();
      return;
    }
    const users =
      src.restrictedAccessFlows || src.RestrictedAccessFlows || [];
    this.selectedUsers = [];
    if (!Array.isArray(users) || users.length === 0) {
      return;
    }
    users.forEach((element) => {
      const email =
        element.emailAddress ||
        element.EmailAddress ||
        element.userEmailAddress ||
        element.UserEmailAddress ||
        element.user?.emailAddress;
      if (!email) {
        return;
      }
      const userName =
        element.userName ||
        element.UserName ||
        element.firstName ||
        element.FirstName ||
        email;
      this.selectedUsers.push({
        emailAddress: email,
        userName,
        profilePicUrl: element.profilePicUrl || element.ProfilePicUrl,
        firstName: element.firstName || element.FirstName || userName,
        IsAccessGiven: true,
      });
    });
    this.refreshAccessMethodFlags();
  }

  getProfileUser(): void {
    if (this.userData != null) {
      this.userserviceService.getProfileUser().subscribe((data) => {
        if (
          data.userData.profilePicUrl === "" ||
          data.userData.profilePicUrl == null
        ) {
          this.showDefaultImage = true;
        } else {
          this.showDefaultImage = false;
          this.profilePicture = data.userData.profilePicUrl;
        }
        this.email = data.userData.emailAddress;
        this.phone = data.userData.phoneNumber;
        this.info = data.userData.info;
        this.website = data.userData.website;
        this.uname = data.userData.userName;
        this.name = data.userData.firstName;
        this.currentPage = 1;
        this.updatePagination();
      });
    }
  }

  private updatePagination() {
    if (!this.tempUsers || this.tempUsers.length === 0) {
      this.totalPages = 1;
      this.paginatedUsers = [];
      this.visiblePageNumbers = [];
      this.startIndex = 0;
      this.endIndex = 0;
      return;
    }

    this.totalPages = Math.ceil(this.tempUsers.length / this.usersPerPage);
    this.currentPage = Math.min(this.currentPage, this.totalPages);
    this.currentPage = Math.max(this.currentPage, 1);

    this.startIndex = (this.currentPage - 1) * this.usersPerPage;
    this.endIndex = Math.min(
      this.startIndex + this.usersPerPage,
      this.tempUsers.length
    );

    this.paginatedUsers = this.tempUsers.slice(this.startIndex, this.endIndex);
    this.updateVisiblePageNumbers();
  }

  private updateVisiblePageNumbers() {
    this.visiblePageNumbers = [];
    if (this.totalPages <= 7) {
      for (let i = 1; i <= this.totalPages; i++) {
        this.visiblePageNumbers.push(i);
      }
    } else {
      if (this.currentPage <= 4) {
        for (let i = 1; i <= 5; i++) this.visiblePageNumbers.push(i);
        this.visiblePageNumbers.push("...");
        this.visiblePageNumbers.push(this.totalPages);
      } else if (this.currentPage >= this.totalPages - 3) {
        this.visiblePageNumbers.push(1);
        this.visiblePageNumbers.push("...");
        for (let i = this.totalPages - 4; i <= this.totalPages; i++)
          this.visiblePageNumbers.push(i);
      } else {
        this.visiblePageNumbers.push(1);
        this.visiblePageNumbers.push("...");
        for (let i = this.currentPage - 1; i <= this.currentPage + 1; i++)
          this.visiblePageNumbers.push(i);
        this.visiblePageNumbers.push("...");
        this.visiblePageNumbers.push(this.totalPages);
      }
    }
  }

  getSelectedUsers(): any[] {
    if (this.selectedUsers && this.selectedUsers.length > 0) {
      return this.selectedUsers;
    }

    const selectedFromAllUsers =
      this.allUsers?.filter(
        (x) => x?.user?.IsAccessGiven || x?.IsAccessGiven
      ) || [];
    const selectedFromTempUsers =
      this.tempUsers?.filter(
        (x) => x?.user?.IsAccessGiven || x?.IsAccessGiven
      ) || [];

    const allSelected = [...selectedFromAllUsers, ...selectedFromTempUsers];
    const uniqueSelected = [];
    const seenEmails = new Set();

    allSelected.forEach((user) => {
      const email = user.user?.emailAddress || user.EmailAddress;
      if (email && !seenEmails.has(email)) {
        seenEmails.add(email);
        uniqueSelected.push(user);
      }
    });

    return uniqueSelected;
  }

  removeSelectedUser(u: any): void {
    if (!this.canUseUserAllowlist) {
      this.promptUpgradeForUserAllowlist();
      return;
    }

    const email = u.emailAddress;
    this.selectedUsers = this.selectedUsers.filter(
      (user) => user.emailAddress !== email
    );

    if (this.allUsers && this.allUsers.length > 0) {
      this.allUsers.forEach((user) => {
        const userEmail = user.user?.emailAddress || user.EmailAddress;
        if (userEmail === email) {
          if (user.user) {
            user.user.IsAccessGiven = false;
          } else {
            user.IsAccessGiven = false;
          }
        }
      });
    }

    if (this.tempUsers && this.tempUsers.length > 0) {
      this.tempUsers.forEach((user) => {
        const userEmail = user.user?.emailAddress || user.EmailAddress;
        if (userEmail === email) {
          if (user.user) {
            user.user.IsAccessGiven = false;
          } else {
            user.IsAccessGiven = false;
          }
        }
      });
    }

    this.accessChanged();
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePagination();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePagination();
    }
  }

  goToPage(page: number | string) {
    if (typeof page === "number" && page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.updatePagination();
    }
  }
}
